import { apiClient } from "../../../services/apiClient";
import { logger } from "../../../services/logger";

export interface ConfidenceCalibrationBucket {
  confidence_range: string;
  min_confidence: number;
  max_confidence: number;
  total_trades: number;
  win_count: number;
  loss_count: number;
  breakeven_count: number;
  win_rate: number;
  avg_pnl_pct: number;
}

export interface ConfidenceCalibrationResponse {
  generated_at: string;
  period_days: number;
  total_trades_analyzed: number;
  buckets: ConfidenceCalibrationBucket[];
}

export interface WinRateByRegimeItem {
  symbol: string;
  direction: string;
  total_trades: number;
  win_count: number;
  loss_count: number;
  breakeven_count: number;
  win_rate: number;
  avg_pnl_pct: number;
  total_pnl_usdt: number;
  avg_confidence: number;
}

export interface WinRateByRegimeResponse {
  generated_at: string;
  period_days: number;
  total_trades_analyzed: number;
  overall_win_rate: number;
  regimes: WinRateByRegimeItem[];
}

export async function getConfidenceCalibration(
  days: number = 90
): Promise<ConfidenceCalibrationResponse> {
  try {
    const response = await apiClient.get<ConfidenceCalibrationResponse>(
      `/admin/reports/confidence-calibration?days=${days}`
    );
    return response.data;
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error));
    logger.error("Failed to fetch confidence calibration", err);
    throw err;
  }
}

export async function getWinRateByRegime(
  days: number = 90
): Promise<WinRateByRegimeResponse> {
  try {
    const response = await apiClient.get<WinRateByRegimeResponse>(
      `/admin/reports/win-rate-by-regime?days=${days}`
    );
    return response.data;
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error));
    logger.error("Failed to fetch win rate by regime", err);
    throw err;
  }
}
